import { tableSchema } from '@nozbe/watermelondb';
import { field } from '@nozbe/watermelondb/decorators';
import Model from './simapp-model';

export const cmtCredentialLevelSchema = tableSchema({
  name: 'cmtCredentialLevel',
  columns: [
    { name: 'b_id', type: 'number', isIndexed: true },
    { name: 'uid', type: 'string', isIndexed: true },
    { name: 'name', type: 'string' },
    { name: 'dev_only', type: 'boolean' }
  ]
});

export default class CmtCredentialLevel extends Model {
  static table = 'cmtCredentialLevel'

  @field('b_id') bId
  @field('uid') uid
  @field('name') name
  @field('dev_only') devOnly
}
